import React from 'react';

import SkeletonLoading from '../../../common/SkeletonLoading';

import BriefTabContainer from './content/briefTab/BriefTabContainer';
import CompetitorsTabContainer from './content/competitorsTab/CompetitorsTabContainer';
import OptimizerTabContainer from './content/optimizerTab/OptimizerTabContainer';
import { contentOptimizerContentTabValues } from './contentOptimizerContentConstants';

const ContentOptimizerPageTabContainer = ({
    tabKey = '',
    viewOnlyMode = false,
    currentContentExists = false,
}) => {
    const spinnerElement = <SkeletonLoading width='98%' />;

    const getOptimizerTabComponent = (tabKey = '') => {
        switch (tabKey) {
            case contentOptimizerContentTabValues.brief.value:
                return !viewOnlyMode ? <BriefTabContainer /> : null;
            case contentOptimizerContentTabValues.optimizer.value:
                return <OptimizerTabContainer />;
            case contentOptimizerContentTabValues.competitors.value:
                return <CompetitorsTabContainer />;
            default:
                return spinnerElement;
        }
    };

    if (!currentContentExists) return spinnerElement;

    return getOptimizerTabComponent(tabKey);
};

export default ContentOptimizerPageTabContainer;
